import { Dictionary } from '@types';
import {IToothPosition} from '@data/models/TreatmentPlan';

export enum ToothMovementPoints {
  CenterOfResistance = 'CenterOfResistance',
  CrownCenter = 'CrownCenter',
  CrownTip = 'CrownTip',
  RootTip = 'RootTip'
}

export interface IToothMovement {
  axialRotationDeg: number;
  buccalLingualAngulationDeg: number;
  buccalLingualTranslation: number;
  extrusionIntrusionTranslation: number;
  mesialDistalAngulationDeg: number;
  mesialDistalTranslation: number;
}

export type IToothMovementDisplacementPerToothOriginPositions = {
    [key in ToothMovementPoints]: IToothMovement;
};

export interface IToothPositionMovement {
  toothLabel?: string;
  toothPosition?: IToothPosition;
  toothMovement: IToothMovement;
  displacementPerToothOriginPositions?: IToothMovementDisplacementPerToothOriginPositions;
}

// Movement data for one stage, key is tooth id, value is movement data for tooth
export type TeethMovementStage = Dictionary<IToothPositionMovement[]>;

// All movement data
export type TeethMovementData = Dictionary<TeethMovementStage>;
